import Hero from "./Hero";
import Features from "./Features";
import Pricing from "./Pricing";
import FAQ from "./FAQ";


export default function Landing() {
  return (
    <>
        <Hero />
        <Features />
        <Pricing />
        <FAQ />
    </>
  );
}
